const CYS ="ijhgfdgghjkiyutfudgchvjhkiuytfydgchvjugyfth"
export const R_KEY_ID="rzp_test_GCHaszAkTob0xN"
export const R_KEY_SECRET="aHQD31OgfWXjUq7eawQqSuVF"
export default CYS;